import React from 'react';
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

const TeamsNettoData = (props) => {
  const calcProps = props.calcProps;
  const styles = props.calcStyles;
  if (!calcProps.filteredPostsByMonth.length) {
    return;
  }
  const monthName = calcProps.filteredPostsByMonth[calcProps.chartDateIndex].month;
  const sumAllCountryHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.client === 'COUNTRY' && post.country !== '' && post.country !== null) {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllIntHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.client === 'INT') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllLogisticsHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.client === 'LOGISTIC') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllLocManagementHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.module === 'Localization_management') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllVacationsHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.module === 'Urlop') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllAbsenceHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (['Nieobecność', 'Zwolnienie lekarskie', 'Zwolnienie z obowiązku świadczenia pracy'].includes(post.module)) {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllEldHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.client === 'ELD') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllWOrgHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.module === 'Organizacja pracy') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const sumAllMeetingsHoursByMonth = (index) => {
    let temp = [];
    calcProps.filteredPostsByMonth[index].posts.forEach((post) => {
      if (post.module === 'Spotkania') {
        temp.push(post.hours);
      }
    });
    return Math.floor(temp.reduce((acc, curr) => acc + curr, 0));
  };

  const chartLaz =
    sumAllCountryHoursByMonth(calcProps.chartDateIndex) +
    sumAllIntHoursByMonth(calcProps.chartDateIndex) +
    sumAllLogisticsHoursByMonth(calcProps.chartDateIndex) +
    sumAllVacationsHoursByMonth(calcProps.chartDateIndex) +
    sumAllAbsenceHoursByMonth(calcProps.chartDateIndex);
  const chartLocMan = sumAllLocManagementHoursByMonth(calcProps.chartDateIndex);
  const chartEld = sumAllEldHoursByMonth(calcProps.chartDateIndex);
  const chartWorg = sumAllWOrgHoursByMonth(calcProps.chartDateIndex);
  const chartMeet = sumAllMeetingsHoursByMonth(calcProps.chartDateIndex);

  const chartDataNetto = {
    labels: ['LAZ summary', 'Localization management', 'ELD technology', 'Work organization', 'Meetings'],
    datasets: [
      {
        data: [chartLaz, chartLocMan, chartEld, chartWorg, chartMeet],
        backgroundColor: ['#4472C4', '#E2F0D9', '#385723', '#548235', '#A9D18E'],
      },
    ],
  };

  const handlePercentage = (data) => {
    const chartData = data.datasets[0].data;
    const reducer = (acc, curr) => acc + curr;
    const total = chartData.reduce(reducer);
    const percentageArr = [];
    chartData.forEach((val) => {
      percentageArr.push(((val * 100) / total).toFixed(2) + '%');
    });
    return percentageArr;
  };

  const chartOptionsNetto = {
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: monthName + ' ' + new Date().getFullYear() + ' netto',
        position: 'top',
      },
    },
  };

  const legendItems = chartDataNetto.labels.map((label, index) => (
    <li key={index}>
      <div style={{ backgroundColor: chartDataNetto.datasets[0].backgroundColor[index] }}></div>
      {label + ' ' + '(' + handlePercentage(chartDataNetto)[index] + ')'}
    </li>
  ));

  const itemsPerColumn = Math.ceil(chartDataNetto.labels.length / 2);
  const colItems1 = legendItems.slice(0, itemsPerColumn);
  const colItems2 = legendItems.slice(itemsPerColumn);

  return (
    <>
      <tr>
        <th>netto</th>
      </tr>
      <tr style={{ position: 'relative' }}>
        <th colSpan="2" className="default" style={styles.default}>
          LAZ Summary
        </th>
        {calcProps.wd.map((_, index) => {
          const laz =
            sumAllCountryHoursByMonth(index) + sumAllIntHoursByMonth(index) + sumAllLogisticsHoursByMonth(index);
          const vacations = sumAllVacationsHoursByMonth(index);
          const absence = sumAllAbsenceHoursByMonth(index);
          const res = laz + vacations + absence;
          return (
            <td
              key={index}
              style={{
                border: 'solid black',
                borderWidth: 'thin',
                width: 'auto',
                padding: '.5rem',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {res.toString().replace('.', ',')}
            </td>
          );
        })}
        <td className="green" style={styles.green}></td>
        <td
          className="chart-cell netto"
          style={
            calcProps.teamIdToFilter !== 'devt' && calcProps.teamIdToFilter !== 'indet'
              ? { top: '-838px', left: '1200px' }
              : { top: '-538px', left: '1200px' }
          }
        >
          <div className="col">
            <div className="chart-wrapper">
              <Chart type="pie" data={chartDataNetto} options={chartOptionsNetto} />
            </div>
            <div className="legend-wrapper">
              <ul>
                <div className="col">{colItems1}</div>
                <div className="col">{colItems2}</div>
              </ul>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th colSpan="2" className="default" style={styles.default}>
          Localization management
        </th>
        {calcProps.wd.map((_, index) => {
          return (
            <td key={index} className="center" style={styles.center}>
              {sumAllLocManagementHoursByMonth(index).toString().replace('.', ',')}
            </td>
          );
        })}
        <td className="green" style={styles.green}></td>
      </tr>
      <tr>
        <th colSpan="2" className="default" style={styles.default}>
          ELD Technology
        </th>
        {calcProps.wd.map((_, index) => {
          return (
            <td key={index} className="center" style={styles.center}>
              {sumAllEldHoursByMonth(index).toString().replace('.', ',')}
            </td>
          );
        })}
        <td className="green" style={styles.green}></td>
      </tr>
      <tr>
        <th colSpan="2" className="default" style={styles.default}>
          Work organization
        </th>
        {calcProps.wd.map((_, index) => {
          return (
            <td key={index} className="center" style={styles.center}>
              {sumAllWOrgHoursByMonth(index).toString().replace('.', ',')}
            </td>
          );
        })}
        <td className="green" style={styles.green}></td>
      </tr>
      <tr>
        <th colSpan="2" className="default" style={styles.default}>
          Meetings
        </th>
        {calcProps.wd.map((_, index) => {
          return (
            <td key={index} className="center" style={styles.center}>
              {sumAllMeetingsHoursByMonth(index).toString().replace('.', ',')}
            </td>
          );
        })}
        <td className="green" style={styles.green}></td>
      </tr>
    </>
  );
};

export default TeamsNettoData;
